import xhr from './../tools/xhr.js';
import dataStorage from './../tools/storage.js';
import markup from './../markup/tools.js';

const body = document.querySelector('body');
const formAdd = body.querySelector('#modal_one_txt_only');
const form = formAdd.querySelector('#modal_one_txt_only-form');
const name = form.querySelector('#modal_one_txt_only-name');
const txt = form.querySelector('#modal_one_txt_only-txt');
const spinner = form.querySelector('#modal_one_txt_only-spinner');
const buttonSubmit = form.querySelector('#modal_one_txt_only-submit');
const buttonCancel = form.querySelector('#modal_one_txt_only-cancel');

const stor = dataStorage.data;
let newUrl;
let newthodURL;
let objecTToClickReload = '';
const showSpinner = () => {
  spinner.classList.remove('invisible');
  buttonSubmit.disabled = true;
  buttonCancel.disabled = true;
};

const hideSpinner = () => {
  spinner.classList.add('invisible');
  buttonSubmit.disabled = false;
  buttonCancel.disabled = false;
};
/*
const showAlert = (input) => {
  if (input.type === 'text') {
    input.classList.add('border');
    input.classList.add('border-danger');
    input.nextElementSibling.innerHTML = validMessage[input.id.match(/[\w]+$/)];
  }
};
*/

const hideAlert = (input) => {
  if (input.type === 'text') {
    input.classList.remove('border');
    input.classList.remove('border-danger');
    input.nextElementSibling.innerHTML = '';
  }
};

const formReset = () => {
  form.reset();

  hideAlert(name);

  hideSpinner();

  buttonSubmit.disabled = true;
  buttonCancel.disabled = false;
};

const callbackXhrSuccess = (response) => {

  hideSpinner();
  formReset();
  $('#modal_one_txt_only').modal('hide');

  switch (response.status) {
  case 200:
    // document.querySelector('#cinemas-reload-btn').click();
    // ТУПО ПЕРЕЧИСЛЕНИЕ !  ПЕРЕДЕЛАТЬ ПОТОМ
    // pointButton.redraw(); обновление фонофого контента

    // if (document.querySelector('#arbitors').classList.contains('active')) 
    //   eventFire(document.querySelector('#arbitors').querySelector('.catalog-header-buttons').querySelector('button[name=refresh]'), 'click');
    
    // if (document.querySelector('#programmsFest').classList.contains('active')) 
    //   eventFire(document.querySelector('#programmsFest').querySelector('.catalog-header-buttons').querySelector('button[name=refresh]'), 'click');
    //   // eventFire(document.getElementById('programmsFest-refresh-btn'), 'click');

    // if (document.querySelector('#places').classList.contains('active')) 
    //   eventFire(document.querySelector('#places').querySelector('.catalog-header-buttons').querySelector('button[name=refresh]'), 'click');
    
    // if (document.querySelector('#ads').classList.contains('active')) 
    //   eventFire(document.querySelector('#ads').querySelector('.catalog-header-buttons').querySelector('button[name=refresh]'), 'click');    

    objecTToClickReload();
    break;
  case 400:
    markup.informationtModal = {
      'title': 'Error',
      'messages': messages.mes400
    };
    break;
  case 271:
    markup.informationtModal = {
      'title': 'Error',
      'messages': response.messages
    };
    break;
  }
};
function eventFire(el, etype) {
  if (el.fireEvent) {
    el.fireEvent('on' + etype);
  } else {
    let evObj = document.createEvent('Events');
    evObj.initEvent(etype, true, false);
    el.dispatchEvent(evObj);
  }
}
const callbackXhrError = () => {
  hideSpinner();
  formReset();
  $('#modal_one_txt_only').modal('hide');

  markup.informationtModal = {
    'title': 'Error',
    'messages': window.appSettings.messagess.xhrError
  };
};

const validateForm = () => {
  let valid = true;
  return valid; // обход блокировки
  /* if(!validPattern.name.test(txt.value)) {
    valid = false;
    showAlert(txt);
  }

  return valid;
*/
};

const submitForm = () => {
  console.log(stor.token);
  let postData = `name=${txt.value}`;
  let urlApp = newUrl.replace('{{FestID}}', stor.currentFestival);
  urlApp = urlApp.replace('{{oper}}', stor.operatorId);

  let response = {
    url: urlApp,
    metod: newthodURL,
    data: postData,
    callbackSuccess: callbackXhrSuccess,
    callbackError: callbackXhrError
  };

  xhr.request = response;
};

const formSubmitHandler = (evt) => {
  evt.preventDefault();

  if (validateForm()) {
    showSpinner();
    submitForm();
  }
};

const addHandlers = (SomeUrl, objecTToClickReloadlocal, mURL) => {
  newUrl = SomeUrl;
  newthodURL = mURL;
  objecTToClickReload = objecTToClickReloadlocal;

  $('#modal_one_txt_only').on('hidden.bs.modal', () => {
    formReset();
  });

  $('#modal_one_txt_only').on('shown.bs.modal', () => {
    window.appFormCurrValue = {
      'name': txt.value,
    };
  });

  form.addEventListener('input', (evt) => {
    hideAlert(evt.target);
    buttonSubmit.disabled = false;
  });

  form.addEventListener('submit', formSubmitHandler);
};


export default {
  start: addHandlers
};
